import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';

function NotFound() {
  return <Redirect to="/" />;
}

export default withRouter(NotFound);
